<template>
    <div>
        <header class="global-header" roll="banner">
            <div class="global-header-container">
                <div class="global-header-title">
                    <h1 class="global-header-title-logo">
                        <router-link to="/home">
                            <img :src="`@/${getLogoPath()}`" alt="" class="hand-mark"/>
                        </router-link>                        
                    </h1>
                </div>
                <div style="display: flex; flex-direction: column;">
                    <div class="global-header-username" v-if="accountInfo != null">
                        {{ accountInfo.name }}様
                    </div>

                    <div class="global-header-username" v-if="clinicInfo != null && !isMobile">
                        {{ clinicInfo.name }}
                    </div>
                </div>                

                <button type="button" class="cart-button" v-on:click="startOrder()" v-if="isShowComponent() && showOrderFunction(clinicInfo)">
                    <div class="cart-container">
                        <div class="cart-icon">
                            <img class="cart-icon-img" src="../../static/img/cart.png" />
                            <span class="cart-count">{{ productsIncart }}</span>
                        </div>
                    </div>
                </button>

                <button type="button" class="drawer-toggle drawer-hamburger" v-if="isShowComponent()">
                    <span class="sr-only">toggle navigation</span>
                    <span class="drawer-hamburger-icon"></span>
                </button>
            </div>            
        </header>

        <OrderFormModal 
        :propsName="orderFormModalName"         
        :propsDisplayItems="displayItems"    
        @selectOrderItem="selectedItem"       
        ref="order_form_modal" />   

        <SelectBillingUserModal 
        :propsName="selectBillingUserModalName" 
        :propsBillings="billingInfoList"
        :propsSelectedBilling="selectBullingInfo"
        @selectedBilling="selectedBilling"
        @callGoOrderForm="goOrderFormPage"
        @callToReOrder="callToReOrder"
        ref="select_billing_modal" />

        <!-- インジケーター -->
        <Indicator ref="indicator" />
    </div>
</template>

<script>
import apiMixins from '../mixins/ApiUtil';
import authUtil from '../mixins/AuthUtil';
import cookieUtil from '../mixins/CookieUtil';
import OrderFormModal from './OrderFormModal.vue';
import SelectBillingUserModal from './SelectBillingUserModal.vue';
import Indicator from './Indicator.vue'
export default {
    name: 'Header',
    mixins: [apiMixins, authUtil, cookieUtil],
    components: {
        OrderFormModal,    
        SelectBillingUserModal,    
        Indicator
    },
    data() {
        return {
            productsIncart: 0,
            orderFormModalName: "header_order_form_modal",       
            selectBillingUserModalName: "header_select_billing_user_modal",     
            CART_OVER_COUNT: "99+",
            orderName: "",                        
            billingInfoList: null,
            accountInfo: null,   // アカウント情報            
            displayItems: [],     
            selectBullingInfo: null,     
            clinicCode: "",
            clinicInfo: null,
            selectedItemType: null,
            isMobile: false        // モバイル表示判定
        }
    },
    methods: {
        //#region API周り
        /**-------------------------------------------------- API ------------------------------------------ */        
        /**
         * カート商品の取得を行う
         */
        requestOrderConfirmation: async function () {
            var userId = await this.getUserId();
            
            var queryStringParameters = {
                clinic_code: this.clinicCode
            }

            const result = await this.requestGetOrderConfirmation(userId, queryStringParameters);

            if (!result || result.data.data.length == 0) {
                return;
            }

            var orderConfirmation = result.data.data;
            this.orderName = orderConfirmation.orderer_name;            
            var cartCount = 0;
            orderConfirmation.products.forEach(function (item) {
                cartCount += item.quantity;                
            });            
            this.productsIncart = cartCount > 99 ? this.CART_OVER_COUNT : cartCount;
        },
        /**
         * 請求先情報の取得を行う
        */
        requestBillings: async function () {                    
            var queryStringParameters = {
                user_id: this.accountInfo.user_id,
                clinic_code: this.clinicCode
            }      
            const result = await this.requestGetBillingList(queryStringParameters);        
                        
            const detail = this.getResultOfGetBillingUser(result);

            if (detail.isSuccess) {
                this.billingInfoList = result.data.data.billings;
            }            
        },
        /**
         * アカウント情報の取得を行う
        */
        requestAccountInfo: async function () {
            const userId = await this.getUserId();

            if (!userId) {
                return;
            }

            const result = await this.requestAccountInfoOfUserSite(encodeURI(userId, 'UTF8'));

            if (result === null || result.data.data.length <= 0) {
                return;
            }

            this.accountInfo = result.data.data;            
        },
        /**
         * 特定クリニック情報の取得を行う
         */
        requestSpecificClinicInfo: async function () {
            const result = await this.requestGetClinic(this.clinicCode);

            if (result === null || result.data.data.length <= 0) {
                return;
            }

            this.clinicInfo = result.data.data;            
        },
        /**------------------------------------------------------------------------------------------------- */
        //#endregion

        //#region 請求先選択・商品種別選択モーダルの各種処理
        /**-----------------------------請求先選択・商品種別選択モーダルの各種処理------------------------------ */                
        /**
         * 注文開始 カートに商品が残っている場合 -> 注文確認画面
         * カートが空の場合 -> 商品種別選択
         */
        startOrder: async function() {
            if (this.productsIncart > 0 || this.productsIncart == this.CART_OVER_COUNT) {
                this.$router.push('/orderconfirmation');
            } else {                
                this.clear();
                this.setOrderItem();
                this.showOrderFormModal();                
            }
        },
        /**
         * 商品種別選択モーダルで選択された際に呼ばれる
         * @param selectedItemType 選択した商品の種別
         */
         selectedItem: async function (selectedItemType) { 
            this.hideOrderFormModal();           
            // 選択した商品種別を一時保管
            this.selectedItemType = selectedItemType;
            
            // 請求先情報の取得
            this.$refs.indicator.doAjax();                                
            await this.requestBillings();
            this.$refs.indicator.onCancel();

            if (this.billingInfoList && this.billingInfoList.length == 1) {
                // 請求先をCookieに保存して、注文フォームへ遷移する
                this.saveBillingOfCookie(this.billingInfoList[0]);
                this.goOrderFormPage();
            } else {
                // 請求先選択
                this.showSelectBillingModal();
            }                
        },
        /**
         * 表示する商品の設定を行う
        */
        setOrderItem () {                        
            var displayItems = [];
            // 一覧に変換
            displayItems = this.convertDisplayItemsToStringArray(this.clinicInfo.display_items);
            // 表示対象広告の設定
            this.displayItems = displayItems;            
        },      
        /**
         * 請求先が選択された際に呼ばれる
         * 請求先の保存を行う
         * @param billing 選択された請求先
         */
        selectedBilling: async function(billing) {                        
            this.selectBullingInfo = billing;
            this.saveBillingOfCookie(billing);            
        },        
        /**         
         * 選択中の請求ユーザーコードをCookieに保存する
         */
        saveBillingOfCookie (billingInfo) {            
            this.setBillingUserCodeToCookie(billingInfo.code);            
        }, 
        /**------------------------------------------------------------------------------------------------- */
        //#endregion
        
        //#region 画面遷移周り
        /**---------------------------------------------- 画面遷移 ------------------------------------------ */       
        /**
         * 注文フォームへ遷移
         */
         goOrderFormPage () {
            this.$router.push({
                name: 'OrderForm',
                query: { type: this.selectedItemType }
            });
        }, 
        /**------------------------------------------------------------------------------------------------- */                
        //#endregion
        
        //#region モーダル表示周り
        /**---------------------------------------------- モーダル表示 ------------------------------------------ */       
        /**
         * 注文メニューのダイアログを表示
        */
        showOrderFormModal() {            
            this.$refs.order_form_modal.show();
        },      
        /**
         * 注文メニューのダイアログを閉じる
         */
        hideOrderFormModal() {
            this.$refs.order_form_modal.hide();
        },
        /**
         * 請求先選択のダイアログを表示
        */
        showSelectBillingModal () {
            this.selectBullingInfo = null;
            this.$refs.select_billing_modal.show();
        },
        /**
         * 請求先選択ダイアログを閉じる
        */
        hideSelectBillingModal () {
            this.$refs.select_billing_modal.hide();            
        },
        /**
         * 請求先のみを選択するダイアログを表示
         */
        showOnlySelectBillingModal: async function () {
            this.$refs.indicator.doAjax();
            // アカウントに紐づく請求ユーザー情報の一覧を取得する
            await this.requestBillings();
            this.$refs.indicator.onCancel();
            this.$refs.select_billing_modal.showSelectBillingUserOnly();
        }, 
        /**----------------------------------------------------------------------------------------------------- */       
        //#endregion

        isShowComponent() {
            return this.isLogin() && this.isAgreedTerms();
        },        
                                     
        clear() {            
            this.billingInfoList = null;
        },    
        callToReOrder () {            
            this.$emit("toReOrder", this.selectBullingInfo.code);
        }    
    },
    mounted: async function () {
        // ログインしていないページ(認証情報がない)である場合通信を行わない
        if (!this.canAccessToCognito()) {
            return;
        }

        this.isMobile =  this.checkMobile();

        this.clinicCode = await this.getClinicCodeForCognito();
        if(this.isShowComponent()) {            
            await this.requestOrderConfirmation();                    
        }
        if (this.orderName) {
            this.$emit("setOrderName", this.orderName); // 担当者名をメインPageに渡す
        }
        if (!this.accountInfo) {            
            await this.requestAccountInfo();    
        }
        if (!this.clinicInfo) {            
            await this.requestSpecificClinicInfo();
        }
    },    
}
</script>


// WEBPACK FOOTER //
// src/components/Header.vue